import axios from 'axios';
import {
  getAccessToken,
  setAccessToken,
  getRefreshToken,
  isTokenExpiredAccessToken,
  isTokenExpiredRefreshToken,
} from './tokenService';
import {
  logoutUserAction,
  setAuthTokenAction,
} from '@/js/reduxstore/actions/authActions';
import { googleLogout } from '@react-oauth/google';
/*
  Backend is accessible at
    backend-stage.makersharks.ai

  Local backend is accessible at
    localhost:8080

  Frontend website accessible at
    stage.makersharks.ai
*/

const ENV = 'stage_testing';

const CONFIG = {
  local_testing: {
    API_URL: 'http://localhost:8080',
    name: 'Local Testing',
  },
  stage_testing: {
    API_URL: 'https://backend-stage.makersharks.ai',
    name: 'Stage deployment',
  },
  production: {
    API_URL: 'https://backend.makersharks.ai',
    name: 'Production deployment',
  },
};

// Warning for me becuase I will forget to change this
if (ENV === 'testing') {
  console.warn(
    '%c⚠️ WARNING: Development Mode Active ⚠️\n' +
      'API is pointing to testing environment.\n' +
      'Make sure to change to production before deploying!',
    'background: #824ad9; color: white; font-size: 12px; padding: 4px; border-radius: 4px;',
  );
}

const createApiClient = (navigate, dispatch) => {
  const apiClient = axios.create({
    baseURL: `${CONFIG[ENV].API_URL}`,
    headers: { 'Content-Type': 'application/json' },
  });

  // Request Interceptor
  apiClient.interceptors.request.use(async (config) => {
    if (config.authRequired === false) {
      return config;
    }
    let token = getAccessToken();
    if (!token || isTokenExpiredAccessToken(token)) {
      try {
        token = await refreshAuthToken();
        console.log('AUTH TOKEN CHANGED -> ' + token);
      } catch {
        // TODO: Show a modal for login
        // logout
        window.location.reload();
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        googleLogout();
        dispatch(logoutUserAction());

        alert('Token expired Login Again');
        navigate('/signin');
        console.log('Token expired, Login Again');
        throw new Error('Token expired, Login Again');
      }
    }
    config.headers['x-auth-token'] = token;
    return config;
  });

  // Response Interceptor
  // apiClient.interceptors.response.use(
  //   (response) => response,
  //   async (error) => {
  //     if (error.response) {
  //       const status = error.response.status;

  //       if (
  //         status === 401 ||
  //         (status === 400 && error.response.data?.error_message)
  //       ) {
  //         const errorMessage = error.response.data?.error_message;

  //         if (errorMessage === 'Auth token not present') {
  //           console.error('Auth token not present, redirecting to login');
  //           navigate('/signin');
  //           return Promise.reject(error);
  //         }

  //         if (errorMessage === 'Auth Token has expired') {
  //           try {
  //             const newToken = await refreshAuthToken();
  //             error.config.headers['x-auth-token'] = newToken;

  //             // Retry the original request
  //             return apiClient.request(error.config);
  //           } catch {
  //             navigate('/signin');
  //             throw new Error('Retry after token refresh failed');
  //           }
  //         }

  //         if (errorMessage === 'Refresh Token has expired') {
  //           // TODO: Show a modal for re-login
  //           console.error('Refresh token expired, redirecting to login');
  //           navigate('/signin');
  //           return Promise.reject(error);
  //         }
  //       }
  //     }

  //     throw error;
  //   },
  // );

  // Helper function to refresh token
  const refreshAuthToken = async () => {
    const refreshToken = getRefreshToken();

    if (!refreshToken || isTokenExpiredRefreshToken(refreshToken)) {
      console.log('Refresh Token Expired');
      throw new Error('Refresh Token Expired');
    }

    try {
      const response = await axios.post(
        `${CONFIG[ENV].API_URL}/refresh/token`,
        {
          refresh_token: refreshToken,
        },
      );
      const newToken = response?.data?.data?.x_auth_key;
      const expiryTime = response?.data?.data?.auth_key_expired_at;
      localStorage.setItem('authKeyExpiredAt', expiryTime);
      setAccessToken(newToken);
      dispatch(setAuthTokenAction(newToken));
      console.log('NEW TOKEN SET to -> ' + newToken);
      return newToken;
    } catch (error) {
      console.error('Failed to refresh token:', error);
      throw error;
    }
  };
  return apiClient;
};

export default createApiClient;
